import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Pager from 'common/components/pager';


export const FORM_NAME = 'PAGER_FORM';

export function mapStateToProps(state, { formName, currentPage }) {
  return {
    formName: formName || FORM_NAME,
    initialValues: {
      page: currentPage,
    },
  };
}

const PagerForm = reduxForm({ form: FORM_NAME })(Pager);

export default withRouter(connect(mapStateToProps)(PagerForm));



// WEBPACK FOOTER //
// ./common/containers/pager.jsx